export default __webpack_public_path__ + "static/media/icon-info.3fc21b27.svg";